<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Centro de costo</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Centro de costo</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="muestraModalAgrega(); showModalAgregar()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px">
        <div class="md-form">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="nomb"
              class="form-control"
              placeholder="Nombre"
              required
              #nomb
              [(ngModel)]="nombreBusquedaCC"
            />
            <label for="nomb">Nombre</label>
          </div>
        </div>
      </div>
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input
            type="radio"
            class="form-check-input"
            id="materialInline1"
            name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado"
            [value]="1"
            mdbInput
          />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input
            type="radio"
            class="form-check-input"
            id="materialInline2"
            name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado"
            [value]="2"
            mdbInput
          />
          <label class="form-check-label" for="materialInline2"
            >Inactivos</label
          >
        </div>

        <div class="form-check form-check-inline">
          <input
            type="radio"
            class="form-check-input"
            id="materialInline3"
            name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado"
            [value]="3"
            mdbInput
          />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>           
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <div></div>
    <button mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="filtraxEstado();">
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cc of listaCentroCosto">
            <td>{{ cc.nombre }}</td>
            <td>
              <mdb-badge *ngIf="cc.activado" pill="true" success="true"
                >Activo</mdb-badge
              >

              <mdb-badge *ngIf="!cc.activado" pill="true" warning="true"
                >Inactivo</mdb-badge
              >
            </td>
            <td>
              <button
                mdbBtn
                type="button"
                size="sm"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                mdbTooltip="Editar"
                (click)="showForEdit(cc);showModalModificar()"
                placement="right"
              >
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button
                *ngIf="!cc.activado"
                (click)="permitirCambioEstado(cc)"
                class="btn-actions-sm"
                color="primary"
                mdbBtn
                type="button"
                mdbWavesEffect
                mdbTooltip="Activar"
                placement="right"
              >
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button
                *ngIf="cc.activado"
                (click)="permitirCambioEstado(cc)"
                class="btn-actions-sm"
                color="success"
                mdbBtn
                type="button"
                mdbWavesEffect
                mdbTooltip="Desactivar"
                placement="right"
              >
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar motivo -->
<div
  mdbModal
  style="overflow-y: auto"
  #agregarCentroCosto="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="agregarCentroCosto.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formAgregarCentroCosto">
            <div class="container">
              <div class="row">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos del Centro de costo
                  </h5>
                </div>
                <div class="col">
                  <div class="switch info-switch">
                    <label
                      >Inactivo<input
                        type="checkbox"
                        color="info"
                        checked=""
                        formControlName="activado"
                      /><span class="lever"></span> Activo
                    </label>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="codigo"
                      class="form-control"
                      placeholder="Código"
                      required
                      formControlName="codigo"
                      maxlength="10"
                      #codigo
                      autocomplete="off"
                    />
                    <label for="codigo">Código</label>
                    <div
                      *ngIf="
                        formAgregarCentroCosto.invalid &&
                        (formAgregarCentroCosto.dirty || formAgregarCentroCosto.touched)
                      "
                    >
                      <mdb-error *ngIf="formAgregarCentroCosto.get('codigo').hasError('required')">
                        El código es requerido
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('codigo').hasError('maxlength')">
                        El código debe tener como máximo 50 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('codigo').hasError('minlength')">
                        El código debe tener como mínimo 3 caracteres
                      </mdb-error>
                    </div>
                  </div>                  
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="nombre"
                      class="form-control"
                      placeholder="Nombre"
                      required
                      formControlName="nombre"
                      maxlength="50"
                      #nombre
                      autocomplete="off"
                    />
                    <label for="nombre">Nombre</label>
                    <div
                      *ngIf="
                        formAgregarCentroCosto.invalid &&
                        (formAgregarCentroCosto.dirty || formAgregarCentroCosto.touched)
                      "
                    >
                      <mdb-error *ngIf="formAgregarCentroCosto.get('nombre').hasError('required')">
                        El nombre es requerido
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('nombre').hasError('maxlength')">
                        El nombre debe tener como máximo 50 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('nombre').hasError('minlength')">
                        El nombre debe tener como mínimo 5 caracteres
                      </mdb-error>
                    </div>
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="descripcion"
                      class="form-control"
                      placeholder="Descripción"
                      required
                      maxlength="100"
                      formControlName="descripcion"
                      #descripcion
                      autocomplete="off"
                    />
                    <label for="descripcion">Descripción</label>
                    <div
                      *ngIf="
                        formAgregarCentroCosto.invalid &&
                        (formAgregarCentroCosto.dirty || formAgregarCentroCosto.touched)
                      "
                    >
                      <mdb-error *ngIf="formAgregarCentroCosto.get('descripcion').hasError('required')">
                        La descripción es requerida
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('descripcion').hasError('maxlength')">
                        La descripción debe tener como máximo 100 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroCosto.get('descripcion').hasError('minlength')">
                        La descripción debe tener como mínimo 3 caracteres
                      </mdb-error>
                    </div>                    
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="agregarCentroCosto.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="button"
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            type="submit"
            (click)="validaExisteCentroCosto();agregarCentroCosto.hide();"
            [disabled]="!formAgregarCentroCosto.valid"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL Editar motivo -->
<div
  mdbModal
  style="overflow-y: auto"
  #editarCentroCosto="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="editarCentroCosto.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formEditarCentroCosto">
            <div class="container">
              <div class="row">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Editar Centro de costo
                  </h5>
                </div>
                <div class="col">
                  <div class="switch info-switch">
                    <label
                      >Inactivo<input
                        type="checkbox"
                        color="info"
                        checked=""
                        formControlName="activado"
                      /><span class="lever"></span> Activo
                    </label>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="codigox"
                      class="form-control"
                      placeholder="Código"
                      required
                      formControlName="codigo"
                      #codigox
                    />
                    <label for="codigox">Código</label>
                  </div>
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="nombrex"
                      class="form-control"
                      placeholder="Nombre"
                      required
                      formControlName="nombre"
                      #nombrex
                    />
                    <label for="nombrex">Nombre</label>
                    <div
                      *ngIf="
                        formEditarCentroCosto.invalid &&
                        (formEditarCentroCosto.dirty || formEditarCentroCosto.touched)
                      "
                    >
                      <mdb-error *ngIf="formEditarCentroCosto.get('nombre').hasError('required')">
                        El nombre es requerido
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroCosto.get('nombre').hasError('maxlength')">
                        El nombre debe tener como máximo 50 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroCosto.get('nombre').hasError('minlength')">
                        El nombre debe tener como mínimo 5 caracteres
                      </mdb-error>
                    </div>                    
                  </div>                
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="descripcion"
                      class="form-control"
                      placeholder="Descripción"
                      formControlName="descripcion"
                      required
                      #descripcion
                    />
                    <label for="descripcion">Descripción</label>
                    <div
                      *ngIf="
                        formEditarCentroCosto.invalid &&
                        (formEditarCentroCosto.dirty || formEditarCentroCosto.touched)
                      "
                    >
                      <mdb-error *ngIf="formEditarCentroCosto.get('descripcion').hasError('required')">
                        La descripción es requerida
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroCosto.get('descripcion').hasError('maxlength')">
                        La descripción debe tener como máximo 100 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroCosto.get('descripcion').hasError('minlength')">
                        La descripción debe tener como mínimo 3 caracteres
                      </mdb-error>
                    </div>                     
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="editarCentroCosto.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="button"
            class="btn btn-secondary waves-light"
            mdbWavesEffect
            type="submit"
            (click)="actualizar();editarCentroCosto.hide();"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
